// extracted by mini-css-extract-plugin
export default {"categoryName":"MockupList_categoryName__hkUA5"};